import update from 'immutability-helper'
import type { FC } from 'react'
import { useCallback, useEffect, useState } from 'react'

import { Card } from './Card'
import { OrderedList } from '@chakra-ui/react'


type ContainerDndProps = {
  cardss: any[],
  onChangeOrder: (params: any) => void
}

export default function ContainerDnd({ cardss, onChangeOrder }: ContainerDndProps) {
  {
    const [cards, setCards] = useState(cardss)

    const moveCard = useCallback((dragIndex: number, hoverIndex: number) => {
      setCards((prevCards: any[]) =>
        update(prevCards, {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, prevCards[dragIndex] as any],
          ],
        }),
      )
    }, [])

    const renderCard = useCallback(
      (card: any, index: number) => {
        return (
          <Card
            key={card._id}
            index={index}
            id={card._id}
            text={card.title}
            moveCard={moveCard}
          />
        )
      },
      [],
    )

    useEffect(() => {
      onChangeOrder(cards)
    }, [cards])

    return (
      <>
        <OrderedList width={"100%"} p={1} className='dnd-list'>

          <div>{cards.map((card, i) => renderCard(card, i))}</div>

        </OrderedList>
      </>
    )
  }
}
